<!--==============================
=            CHARTJS             =
===============================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Charts js</div>
      </base-header>
    </v-row>
    <v-row>
      <template>
       
        <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header">

            PLanet chart
            </div><div slot="card-subheader">Id aliqua reprehenderit id duis nulla voluptate voluptate laborum esse do
              eiusmod. Nostrud in magna ullamco incididunt ullamco. Ea non eiusmod laboris ullamco deserunt velit.</div>
            <div slot="card-body">
            <canvas id="planet-chart"></canvas>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header">

            Bar
            </div><div slot="card-subheader">Id aliqua reprehenderit id duis nulla voluptate voluptate laborum esse do
              eiusmod. Nostrud in magna ullamco incididunt ullamco. Ea non eiusmod laboris ullamco deserunt velit.</div>
            <div slot="card-body">
                <canvas id="bar-chart"></canvas>
            </div>
          </base-card>
        </v-col>
       

      </template>
    </v-row>
     <v-row>
      <template>
       
        <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header">

         Bubble
            </div><div slot="card-subheader">Id aliqua reprehenderit id duis nulla voluptate voluptate laborum esse do
              eiusmod. Nostrud in magna ullamco incididunt ullamco. Ea non eiusmod laboris ullamco deserunt velit.</div>
            <div slot="card-body">
               <canvas id="bubble-chart"></canvas>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header">

             Line
            </div><div slot="card-subheader">Id aliqua reprehenderit id duis nulla voluptate voluptate laborum esse do
              eiusmod. Nostrud in magna ullamco incididunt ullamco. Ea non eiusmod laboris ullamco deserunt velit.</div>
            <div slot="card-body">
              <canvas id="line-chart"></canvas>
            </div>
          </base-card>
        </v-col>
       

      </template>
    </v-row>

  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
   import {
    planetChartData,
    lineChartData,
    barChartData,
    bubbleChartData
  } from '../../util/chart-data.js';
  export default {
    components: {
      BaseCard,
      BaseHeader,
      planetChartData,
      lineChartData,
      barChartData,
      bubbleChartData
    },
    data() {
      return {
        planetChartData: planetChartData,
        lineChartData: lineChartData,
        barChartData: barChartData,
        bubbleChartData: bubbleChartData

      }
    },
    methods: {
      createChart(chartId, chartData) {
        const ctx = document.getElementById(chartId);
        const myChart = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
      }
    },
    mounted() {
      this.createChart('planet-chart', this.planetChartData);
      this.createChart('line-chart', this.lineChartData);
      this.createChart('bar-chart', this.barChartData);
      this.createChart('bubble-chart', this.bubbleChartData);
    }
  };
</script>

<!--====  End of CHARTJS   ====-->
